/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface AddressesResponse {

        "addresses"?: Array<Address>;
    }

}
